export default __webpack_public_path__ + "3fbdfc26a2ffe6e09f1e95c1a7fdbffa.jpg";